export enum SkeletonType {
    text = 'text',
    rectangle = 'rectangle'
}
